/**
 * SorteioPendentes — seção "Aguardando sorteio" da lista de jogadores
 * (criação mediada, fase 3a). Renderizada no SidePanel quando a mesa está
 * mediada; o botão 🎲 só chega para o mestre (via prop onSortear).
 *
 * O sorteio roda no servidor; o clique dispara a cerimônia (dado girando para
 * a mesa toda + revelação da ficha + linha no chat).
 */
import { Button } from '@/components/ui/button'

export interface SorteioPendente {
  userId: string
  name: string
}

interface SorteioPendentesProps {
  pendentes: SorteioPendente[]
  /** Presente só para o mestre — habilita o botão de sortear. */
  onSortear?: (userId: string) => void
  sorteandoUserId?: string | null
}

export function SorteioPendentes({ pendentes, onSortear, sorteandoUserId }: SorteioPendentesProps) {
  if (pendentes.length === 0) return null

  return (
    <div className="border-b border-game-border-primary dark:border-zinc-800 p-4">
      <p className="mb-1 text-xs font-semibold uppercase tracking-[0.2em] text-game-muted dark:text-zinc-500">
        Aguardando sorteio
      </p>
      <p className="mb-3 text-xs text-game-muted dark:text-zinc-500">
        {onSortear
          ? 'Sorteie o personagem de cada jogador — todos veem a revelação.'
          : 'O mestre sorteará os personagens em breve.'}
      </p>
      <ul className="space-y-2">
        {pendentes.map(p => (
          <li key={p.userId} className="flex items-center justify-between gap-2">
            <span className="truncate text-sm font-medium text-game-primary dark:text-zinc-100">
              {p.name}
            </span>
            {onSortear && (
              <Button
                size="sm"
                onClick={() => onSortear(p.userId)}
                disabled={sorteandoUserId != null}
                className="h-7 px-3 text-xs font-bold uppercase tracking-wide"
              >
                {sorteandoUserId === p.userId ? 'Sorteando…' : '🎲 Sortear'}
              </Button>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default SorteioPendentes
